//IApplauded.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';

const IApplauded = () => {
  const location = useLocation();
  const authState = useSelector(state => state.authReducer);
  const [applauses, setApplauses] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [name, setName] = useState('');
  const [place, setPlace] = useState('');
  const [tags, setTags] = useState('');
  const [applauseTo, setPurpose] = useState('');
  const [purposeHead, setPurposeHead] = useState('');
  const [selectedApplauseId, setSelectedApplauseId] = useState(null);
  const [iApplauded, setIApplauded] = useState(false);
  const [selfApplause, setSelfApplause] = useState(false);
  const [applauseForMe, setApplauseForMe] = useState(false);
  const [applauseRoute, setApplauseRoute] = useState("i-applauded");

  useEffect(() => {
    const myRoute = (location?.pathname || '').split('/').pop() || '';
    setApplauseRoute(myRoute);
  }, [location.pathname, setApplauseRoute]);

  const fetchApplauses = useCallback(async () => {
    if (!authState.isLoggedIn) return;
    // console.log("My applause applauseRoute: ", applauseRoute);

    let url;
    switch (applauseRoute) {
      case 'self-applause':
        url = "/applause/self";
        break;
      case 'applause-for-me':
        url = "/applause/forme";
        break;
      default:
        url = "/applause/iapplauded";
        break;
    }

    const config = {
      url,
      method: "post",
      headers: { Authorization: authState.token },
      data: { userId: authState.user._id, nameCode: authState.user.thin5whyscode }
    };

    // console.log("My applause Search Payload: ", applauseRoute, config);

    try {
      const data = await fetchData(config, { showSuccessToast: false });
      setApplauses(data.applauses);
    } catch (error) {
      console.error('Error fetching applauses:', error);
    }
  }, [applauseRoute, authState.token, authState.user._id, authState.user.thin5whyscode, authState.isLoggedIn, fetchData, setApplauses]);

  useEffect(() => {
    fetchApplauses();
  }, [fetchApplauses]);

  const [isDeleteClicked, setIsDeleteClicked] = useState(false);
  const deleteClicked = () => {
    setIsDeleteClicked(true);
  }
  
  const noDeleteClicked = () => {
    setIsDeleteClicked(false);
  }
  
  const handleDelete = (id) => {
    const config = {
      url: `/applause/${id}`,
      method: "delete",
      headers: { Authorization: authState.token }
    };
    fetchData(config).then(() => fetchApplauses());
  }

  const handleView = (applauseId) => {
    setSelectedApplauseId(prevId => (prevId === applauseId ? null : applauseId));
  };

  const handleCloseApplauseDetails = () => {
    setSelectedApplauseId(null);
  };

  const handleApplauseClick = (ApplauseId) => {
    setSelectedApplauseId(ApplauseId);
  };

  const handleApplauseShare = (ApplauseId) => {
    setSelectedApplauseId(ApplauseId);
  };

  const handleApplauseSave = (ApplauseId) => {
    setSelectedApplauseId(ApplauseId);
  };

  const handleApplausePrint = (ApplauseId) => {
    setSelectedApplauseId(ApplauseId);
  };

  const formatDateTime = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

  const sortedApplauses = [...applauses].sort((a, b) => new Date(b.applauseDate) - new Date(a.applauseDate));

  return (
  <div className="min-h-screen bg-black py-2">
    <div className='border-b border-blue-400'>
      <h2 className="text-lg lg:text-xl font-bold text-yellow-200 text-center mb-2">
        👍 I Applauded
      </h2>
    </div>
    <div className="min-h-[80vh] p-4 mt-2">
      {/* Header with Add New */}
      {applauses && applauses.length !== 0 && (
        <div className="flex justify-between items-center py-2 border-b border-gray-400">
          <h3 className="text-m lg:text-lg mt-1 mx-2 text-white">
            {applauses.length} Applauses By You Found!
          </h3>
          <Link
            to="/applause/add"
            className="flex items-center px-3 py-2 text-sm lg:text-lg bg-blue-500 rounded hover:bg-blue-600"
          >
            <FontAwesomeIcon icon={faPlus} className="mr-2" />
            Add New
          </Link>
        </div>
      )}

      {loading ? (
        <Loader />
      ) : (
        <div>
          {applauses && applauses.length === 0 ? (
            <div className="h-[300px] flex flex-col items-center justify-center gap-4 text-yellow-300">
              <h3 className="text-xl text-orange-400 mb-4">
                No Applause Record Found!
              </h3>
              <Link
                to="/applause/add"
                className="flex items-center px-3 py-2 bg-blue-500 rounded hover:bg-blue-600"
              >
                <FontAwesomeIcon icon={faPlus} className="mr-2" />
                Add New
              </Link>
            </div>
          ) : (
            sortedApplauses.map((applause, index) => (
              <div
                key={applause._id}
                className="bg-black border border-gray-600 my-4 p-4 text-white rounded-lg shadow-lg"
              >
                <div className="flex items-center">
                  <span className="font-medium text-sm lg:text:m">
                    #{index + 1} To {applause.applauseTo} {applause.name} On{" "}
                    {formatDateTime(applause.applauseDate)}
                  </span>

                  {/* Action Icons */}
                  <div className="ml-auto flex items-center gap-2">
                    <Tooltip text="View details" position="top">
                      <span
                        className="text-blue-500 cursor-pointer"
                        onClick={() => handleView(applause._id)}
                      >
                        <i className="fa-solid fa-eye"></i>
                      </span>
                    </Tooltip>

                    <Tooltip text="Edit this record" position="top">
                      <Link
                        to={`/applause/${applause._id}`}
                        className="text-green-600 cursor-pointer"
                      >
                        <i className="fa-solid fa-pen"></i>
                      </Link>
                    </Tooltip>

                    <Tooltip text="Delete this record" position="top">
                      <span
                        className="text-red-500 cursor-pointer"
                        onClick={() => deleteClicked()}
                      >
                        <i className="fa-solid fa-trash"></i>
                      </span>
                    </Tooltip>
                  </div>
                </div>

                {/* Delete Confirmation */}
                {isDeleteClicked && (
                  <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
                    <div className="bg-blue-200 text-black p-4 rounded flex flex-col sm:flex-row gap-4">
                      <button
                        className="bg-red-700 w-full sm:w-40 text-white p-2 rounded"
                        onClick={() => handleDelete(applause._id)}
                      >
                        Confirm To Delete
                      </button>
                      <button
                        className="bg-yellow-300 w-full sm:w-40 text-black p-2 rounded"
                        onClick={() => noDeleteClicked()}
                      >
                        No I Do Not Want To Delete
                      </button>
                    </div>
                  </div>
                )}

                {/* Selected Applause Details */}
                {selectedApplauseId === applause._id && (
                  <div className="bg-black border border-gray-500 text-white mt-2 p-2 rounded-m">
                    <h2 className="text-blue-600 text-sm lg:text-m font-semibold">
                      You Applauded To: {applause.applauseTo} {applause.name}
                    </h2>
                    {applause.reply && (
                      <>
                        <p className="text-purple-700">
                          <strong>Applausee Reply:</strong> {applause.reply}
                        </p>
                        <p className="text-purple-700">
                          <strong>Reply Date:</strong>{" "}
                          {formatDateTime(applause.replyDate)}
                        </p>
                      </>
                    )}
                    <p className='text-sm lg:text-m'>
                      <strong>Headline:</strong> {applause.title}
                    </p>
                    <p className='text-sm lg:text-m'>
                      <strong>Message:</strong> {applause.description}
                    </p>
                    <p className='text-sm lg:text-m'>
                      <strong>Remarks:</strong> {applause.remarks}
                    </p>
                    <p className='text-sm lg:text-m'>
                      <strong>Influencer Think5Whys Code:</strong>{" "}
                      {applause.influencerCode}
                    </p>
                    <p className='text-sm lg:text-m'>
                      <strong>Instagram Id:</strong> {applause.instagramId}
                    </p>
                    <p className='text-sm lg:text-m'>
                      <strong>Date:</strong> {formatDateTime(applause.applauseDate)}
                    </p>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      )}
    </div>

    {/* Footer */}
    <footer className="bg-black border-t border-blue-400 text-gray-400 py-4 mt-8">
      <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
        <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
        <div className="flex flex-wrap gap-4 text-sm">
          <Link to="/about-us" className="hover:text-teal-300">
            About
          </Link>
          <Link to="/privacy-policy" className="hover:text-teal-300">
            Privacy Policy
          </Link>
          <Link to="/terms-of-use" className="hover:text-teal-300">
            Terms of Use
          </Link>
          <Link to="/contact-us" className="hover:text-teal-300">
            Contact
          </Link>
        </div>
      </div>
    </footer>
  </div>
  );
}

export default IApplauded;
